import { ElementData, ElementDataValue, FormElement } from '../../lib/types'
import React from 'react'
import ChangeIndicator from './change-indicator'
import { Tooltip } from '@carbon/react'
import { Information } from '@carbon/icons-react'
import { getCaseInsensitive } from '../../lib/get-id'

type Props = {
    original: ElementData
    data: ElementData
    prevData?: ElementData
    element: FormElement
    onChange: (field: string, value: ElementDataValue) => void
}

export default function FormSelectElement(props: Props) {
    const { element, data, prevData, original, onChange } = props
    let changed =
        getCaseInsensitive(data, element.field || '') !== getCaseInsensitive(original, element.field || '') ||
        (prevData ? getCaseInsensitive(data, element.field || '') !== getCaseInsensitive(prevData, element.field || '') : false)
    const selectedValue = String(getCaseInsensitive(data, element.field!) || '');
    const currentOptions = element.values || [];
    const isSelectedValueInCurrentOptions = currentOptions.some(val => val === selectedValue);

    return (
        <div className='mt-2'>
            <label className='font-bold text-blue-700'>
                {element.label || element.field}
                {element.required && <span className='text-red-300 mx-1'>*</span>}
                {!prevData && <ChangeIndicator changed={changed} />}
                {changed && prevData && (
                    <Tooltip
                        align='bottom'
                        label={getCaseInsensitive(prevData, element.field || '') + ' → ' + getCaseInsensitive(data, element.field || '')}
                    >
                        <span className='cursor-pointer ml-1 flex flex-row items-center'>
                            <Information />
                        </span>
                    </Tooltip>
                )}
            </label>
            <div>
                <select
                    className='form-select'
                    value={selectedValue}
                    onChange={(e) => onChange(element.field!, e.target.value)}
                    disabled={element.readonly}
                    style={{ borderColor: changed ? 'Highlight' : '#ADB0B3' }}
                >
                    <option value='' />
                    {!isSelectedValueInCurrentOptions && selectedValue && (
                        <option key={selectedValue} value={selectedValue} hidden>
                            {selectedValue}
                        </option>
                    )}
                     {currentOptions.map((val) => (
                        <option key={val} value={val}>
                            {val}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}
